import React from "react";
import { useGame } from "../game/em2c-store";
import { AlertTriangle, AlertOctagon, Info } from "lucide-react";

const LEVELS = {
  info: { color: "#00fa9a", Icon: Info },
  warning: { color: "#ffc107", Icon: AlertTriangle },
  critical: { color: "#ff3366", Icon: AlertOctagon },
};

export default function Notifications() {
  const notifications = useGame((s) => s.notifications);
  return (
    <div className="absolute bottom-[220px] right-3 z-30 pointer-events-none flex flex-col gap-2 w-80" data-testid="notifications">
      {notifications.map((n) => {
        const meta = LEVELS[n.level] || LEVELS.info;
        return (
          <div
            key={n.id}
            className="flex items-start gap-2 p-2 bg-[#0A0C10]/95 backdrop-blur border-l-2 border border-white/10"
            style={{ borderLeftColor: meta.color, fontFamily: "Rajdhani, sans-serif" }}
          >
            <meta.Icon size={14} className="mt-0.5 shrink-0" style={{ color: meta.color }} />
            <div className="text-xs font-mono text-slate-100 leading-tight">{n.text}</div>
          </div>
        );
      })}
    </div>
  );
}
